export default {
    agreement_categories: "Agreement categories",
    app_code: "Initiator application code",
    authentication_login: "Authentication login",
    authentication_password: "Authentication password",
    cod_no: "Code NO",
    credentials_of_authorized_person: "Authorization of authorized person",
    director: "Director",
    do_you_confirm_sending_feedback_url_to_patient_messenger: "Do you confirm sending the link to write a review to the patient in the messenger?",
    do_you_confirm_sending_receipt_to_patient_messenger: "Do you confirm sending receipt to patient's messenger?",
    employee_login: "Employee login",
    employee_password: "Employee password",
    fdoc_instruction: "For the service to work correctly, pass the IP address to which you will receive hooks/requests to the FDoc manager: <code>{ipaddress}</code>. Also name the events you want to receive: <code>SetStatus, SetStatusMessage, SetStatusPackageByClient</code>",
    fdoc_multiple_signers_instruction: "In the staff section, in the employee edit, in FDoc tab, the employee's login and password from the FDoc system must be specified.",
    files: "Files",
    files_being_uploaded: "Files are being uploaded. Do not close the page until the upload is complete.",
    fill_questionary: "Fill out the questionnaire",
    first_new: "New ones first",
    first_old: "First the old ones",
    gallery: "Gallery",
    header_in_akt: "Cap in the act of services rendered",
    multiple_signers_support: "Support for multiple signers",
    options: "Options",
    or_folder_with_dcm_files: "or a folder with DCM files",
    select_folder: "Select folder",
    send_receipt_to_messenger: "Send receipt to patient's messenger",
    sign_selected_via_vendor: "Sign selected via {vendor}",
    table: "Table"
}
